<template lang="pug">
div
  v-row(no-gutters :style="`min-height: ${viewHeight};`")
    v-col.px-8.shrink
      div.sticky.white(style="width: 230px; top: 106px;")
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Marketing settings
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="member && member.id === company.primary_owner" @click="$router.push('/admin/clinic/settings/wallet')") Wallet

    v-col.grow.neutral200
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

      template(v-else)
        v-container.pa-8(fluid style="max-width:1100px")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text Marketing settings

          v-form(ref="form")
            v-card.pa-6.mt-4.round-xl(outlined)
              div.text-md.font-semibold.neutral700--text Loyalty
              v-card.pa-6.mt-4.round-xl(outlined)
                v-row(align="center")
                  v-col.shrink(align="center")
                    v-img(v-if="settings.loyalty_system === 'stamps'" :src="require('@/assets/images/loyalty_stamp.png')" width="120")
                    v-img(v-if="settings.loyalty_system === 'points'" :src="require('@/assets/images/loyalty_point.png')" width="113")
                  v-col
                    div.text-md.font-semibold.neutral700--text You are currently using {{ settings.loyalty_system }} loyalty system
                    div.text-md.neutral700--text.mt-1 Collect {{ settings.loyalty_system }} and decide the rewards to give to your customer once they’ve achieved certain {{ settings.loyalty_system === 'points' ? 'points amount!' : 'progress!'}}
                  v-col.shrink
                    y-button(label="Switch system" prepend-icon="$yzi-refresh-cw-02" icon-size="18" outlined size="sm" @click="showSwitchSystemDialog = true")
            
            v-card.pa-6.mt-4.round-xl(outlined)
              div.text-md.font-semibold.neutral700--text WhatsApp Access Token
              div.d-flex.align-center.mt-5
                div.text-sm.font-semibold.neutral500--text Insert WhatsApp Access Token
                v-spacer
                y-button.mr-4(label="How to get Access Token?" size="sm" underline append-icon="$yzi-share-03" icon-size="16" icon-color="neutral700" button-class="px-0" @click="getApiKey")
              v-text-field.text-sm.mt-1.round-xl(v-model="settings.whatsapp_api_key" placeholder="Insert Access Token" outlined dense height="48" hide-details="auto")
              div.d-flex.align-center.mt-4
                div.text-sm.font-semibold.neutral500--text Insert WhatsApp Phone Number ID
                v-spacer
                y-button.mr-4(label="How to get Phone Number ID?" size="sm" underline append-icon="$yzi-share-03" icon-size="16" icon-color="neutral700" button-class="px-0" @click="getPhoneId")
              v-text-field.text-sm.mt-1.round-xl(v-model="settings.whatsapp_id" placeholder="Insert Phone Number ID" outlined dense height="48" hide-details="auto")
            
            v-card.pa-6.mt-4.round-xl(outlined)
              div.text-md.font-semibold.neutral700--text SMS header
              div.text-md.neutral700--text.mt-1 As per SKMM guidelines, you shall include price information at the beginning of each SMS. All Malaysia mobile number will be minus 4 characters “RM0” at the beginning of each SMS content.
              v-row
                v-col
                  div.text-sm.font-semibold.neutral500--text.mt-4 SMS header
                  v-text-field.text-sm.mt-1.round-xl(v-model="settings.sms_header" prefix="RM0" placeholder="Enter header here" outlined dense height="48" hide-details="auto")
                v-col

  v-footer.white.py-3.px-10(app inset padless elevation="3")
    v-spacer
    y-button.mr-4(:label="$t('cancel')" underline button-class="px-0" @click="goBack")
    y-button(label="Save" :loading="isLoading" @click="saveData")
  .dialogs
    switch-loyalty-system-dialog(v-if="showSwitchSystemDialog" :open.sync="showSwitchSystemDialog" :loyalty-system.sync="settings.loyalty_system")

</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import SwitchLoyaltySystemDialog from '@/components/clinic/marketing/dialogs/SwitchLoyaltySystemDialog.vue'

export default {
  name: 'MarketingSettings',
  components: { SwitchLoyaltySystemDialog },
  data: () => ({
    isFetching: false,
    isLoading: false,
    showSwitchSystemDialog: false,
    settings: {}
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      displaySize: 'ui/getDisplaySize'
    }),
    ...mapState('user', ['member']),
    viewHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '130vh'
        case 'x-small':
          return '114vh'
        case 'small':
          return '106vh'
        case 'medium':
          return '92vh'
        case 'large':
          return '81vh'
        case 'x-large':
          return '81vh'
        default:
          return '81vh'
      }
    }
  },
  mounted () {
    this.fetchMarketingSettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMarketingSettings () {
      this.isFetching = true
      this.$axios.get(`/marketing/${this.company.slug}`)
        .then(resp => {
          this.settings = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    getApiKey () {
      let url = 'https://developers.facebook.com/docs/whatsapp/business-management-api/get-started/'
      window.open(url,'_blank')
    },
    getPhoneId () {
      let url = 'https://developers.facebook.com/docs/whatsapp/cloud-api/phone-numbers'
      window.open(url,'_blank')
    },
    saveData () {
      this.isLoading = true
      this.$axios.patch(`/marketing/${this.company.slug}`, this.settings)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>